import { type ProductData } from "~/domains/product/types/ProductData";
import { resolveUrl } from "~/utils/url/urlResolver";
import { prepareRestrictionValue } from "~/features/PackageRestriction/utils/augmentPDPUrlWithRestriction";
import { usePackageRestrictionContext } from "~/features/PackageRestriction/PackageRestrictionContext";
import { PURCHASE_PLACE_PARAM, PURCHASE_TYPE_PARAM } from "~/app/analytics/ga/recommendations/constants";
import { PDP_RESTRICTION_URL_PARAM } from "~/features/PackageRestriction/utils/constants";
import { usePurchasePlace } from "~/app/analytics/ga/recommendations/RecommendationContexts";
import type { PurchasePlace, PurchaseType } from "~/app/analytics/ga/recommendations/types";

export const useProductDetailsUrl = (
  productData: Pick<ProductData, "url" | "sapMaterialNumber">,
  reco_type?: PurchaseType,
  external_reco_place?: PurchasePlace,
  additionalParams: Record<string, string> = {},
) => {
  const reco_place = usePurchasePlace();
  const restrictedCode = usePackageRestrictionContext();

  const url = resolveUrl(productData.url);

  if (!url) {
    return url;
  }

  if (restrictedCode) {
    additionalParams[PDP_RESTRICTION_URL_PARAM] = prepareRestrictionValue(
      productData.sapMaterialNumber + restrictedCode,
    );
  }
  if (reco_type) {
    additionalParams[PURCHASE_PLACE_PARAM] = external_reco_place ?? reco_place;
    additionalParams[PURCHASE_TYPE_PARAM] = reco_type;
  }

  const urlObj = new URL(url.startsWith("/") ? window.location.origin + url : url);
  const params = urlObj.searchParams;
  Object.entries(additionalParams).forEach(([key, value]) => {
    params.set(key, value);
  });
  return urlObj.toString();
};
